var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"packery",rawName:"v-packery",value:({ itemSelector: _vm.itemSelector, percentPosition: _vm.percentPosition }),expression:"{ itemSelector, percentPosition }"}],staticClass:"-m-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }